/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface Session
 */
export interface Session {
    /**
     * The session-wide commands, typically rendered as main navigation menu
     * @type {Array<Command>}
     * @memberof Session
     */
    commands: Array<Command>;
    /**
     * 
     * @type {User}
     * @memberof Session
     */
    user?: User;
    /**
     * User settings configuration, as key/value pairs
     * @type {any}
     * @memberof Session
     */
    userSettingsConfiguration?: any;
}

/**
 * Check if a given object implements the Session interface.
 */
export function instanceOfSession(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "commands" in value;

    return isInstance;
}

export function SessionFromJSON(json: any): Session {
    return SessionFromJSONTyped(json, false);
}

export function SessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Session {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'commands': ((json['commands'] as Array<any>).map(CommandFromJSON)),
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'userSettingsConfiguration': !exists(json, 'userSettingsConfiguration') ? undefined : json['userSettingsConfiguration'],
    };
}

export function SessionToJSON(value?: Session | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'commands': ((value.commands as Array<any>).map(CommandToJSON)),
        'user': UserToJSON(value.user),
        'userSettingsConfiguration': value.userSettingsConfiguration,
    };
}

